<div class='panel panel-primary trans-grid' style="padding: 0px; border: 5px double;">

  <div #popBox style="position:absolute;width:1px;height:1px;">
    <!--<ng-template #popTitle let-language="language"></ng-template>-->
    <ng-template #popContent let-greeting="greeting">
      <div class="clearfix input-section memberPop">
        <div class="section-45 profile-info">
          <div class="clearfix">
            <div class="profile-pic fl s2">
              <img [src]="profileImageUrl" alt="profile" />
            </div>
          </div>
          <div class="clearfix">
            <div class="title"> <b> {{popMember.Salutation}} {{popMember.FirstName}} {{popMember.LastName}} </b> </div>
          </div>
          <div class="clearfix">
            <span class="fieldname">Reg ID:</span> <span class="fieldvalue"> {{popMember.IdentityId}}</span>
          </div>
          <div class="clearfix">
            <span class="fieldname">User Name: </span> <span class="fieldvalue"> {{popMember.UserName}}</span>
          </div>


        </div>
        <div class="section-50 profile-info">
          <div class="clearfix">
            <span class="fieldname">Active:</span> <span class="fieldvalue"><mat-checkbox [disabled]="true" [(ngModel)]="popMember.IsActive"></mat-checkbox> </span>
          </div>
          <div class="clearfix">
            <span class="fieldname">Start:</span> <span class="fieldvalue"> {{popMember.MembershipStartDate?.toLocaleDateString('en-GB')}}</span>
          </div>
          <div class="clearfix">
            <span class="fieldname">End:</span> <span class="fieldvalue"> {{popMember.MembershipExpiryDate?.toLocaleDateString('en-GB')}}</span>
          </div>
          <div class="clearfix">
            <span class="fieldname">Date of Birth: </span> <span class="fieldvalue"> {{popMember.DateOfBirth?.toLocaleDateString('en-GB')}}</span>
          </div>
          <div class="clearfix">
            <span class="fieldname">Trainer: </span> <span class="fieldvalue"> {{popMember.AssignedTrainer?.FirstName}} {{popMember.AssignedTrainer?.LastName}}</span>
          </div>
          <div class="clearfix">
            <span class="fieldname">Referred By:</span> <span class="fieldvalue"> {{popMember.ReferredBy?.FirstName}} {{popMember.ReferredBy?.LastName}} </span>
          </div>
          <div class="clearfix">
            <span class="fieldname">Enrolled By:</span> <span class="fieldvalue">{{popMember.EnrolledBy?.FirstName}} {{popMember.EnrolledBy?.LastName}} </span>
          </div>
          <div class="clearfix">
            <span class="fieldname">Occupation:</span> <span class="fieldvalue">{{popMember.Occupation}} </span>
          </div>
          <div class="clearfix">
            <span class="fieldname">Contact:</span> <span class="fieldvalue"> {{popMember.Contact1}} {{popMember.Contact2 ?"/ "+popMember.Contact2 : ""}}</span>
          </div>
          <div class="clearfix">
            <span class="fieldname">Email:</span> <span class="fieldvalue"> {{popMember.Email}}</span>
          </div>
        </div>
      </div>

    </ng-template>
    <div class="btnPopoverTrigger"
         [ngbPopover]="popContent"
         popoverTitle=""
         [autoClose]="true"
         ngbPopover=""
         popoverClass="popOverride"
         #memberInfoPop="ngbPopover" placement="auto">
    </div> <!--[popoverTitle]="popTitle"-->
  </div>

  <div class="alert alert-info" role="alert" *ngIf="indLoading"><img src="../assets/images/loader2.gif" width="32" height="32" /> Loading...</div>
  <div class="filter-controls trans-back" style="width: 582px;">
    <!--<input type="text" class="form-control search-box" [value]="filter" (input)="filter = $event.target.value" (keyup.enter)="filterChange();" placeholder="Filter">-->
    <div class="search-box hide" style="padding-top:12px;width:710px !important;">
      <span>&nbsp;</span>

    </div>
    <div class="fl" style="width: 100%; font-size: 1.15em;">
      <div class="fl expiringMembership" style="width:25%;">
        Enquiry Follow-ups in:
      </div>
      <div class="field-s fl" style=" margin-top: 3px; width: 4%;">
        <input type="Number" class="input-element-nb w-100" placeholder="Days" [(ngModel)]="dayCount" (change)="dayCountChanged()">
      </div>
      <div class="fl expiringMembership padding-lxs" style="width:10%;">
        Days
      </div>
      <div class="fl" style="border-left: 1px solid #595959; padding-left: 14px; font-size: 13px; font-weight: bold; height: 36px; width: 21%; ">
        <mat-form-field class="fl w-100 mat-custom-label-adjust">
          <mat-select placeholder="Status" [(ngModel)]="selectedStatus" style="height:23px;" (selectionChange)="onUserStatusChanged($event.value)">
            <mat-option value="">---select---</mat-option>
            <mat-option *ngFor="let f of userStatus" [value]="f">
              {{f?.Name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="fl" style="border-left: 1px solid #595959; padding-left: 14px; font-size: 13px; font-weight: bold; height:36px;width:26%; ">
        <mat-form-field class="fl w-100 mat-custom-label-adjust">
          <mat-select placeholder="Sub-Status" [(ngModel)]="selectedSubStatus" style="height:23px;" (selectionChange)="filterChanged()">
            <mat-option value="">---select---</mat-option>
            <mat-option *ngFor="let f of userSubStatus" [value]="f">
              {{f?.Name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="fl" style="border-left: 1px solid #595959; padding-left: 14px;padding-top:6px; font-size: 13px; font-weight: bold; height:36px;width:13%; ">
        <mat-checkbox [(ngModel)]="getAllFollowups" (change)="filterChanged()">All Days</mat-checkbox>
      </div>
      <input type="button" class="fl filterBtn hide" value="View" (click)="getCollectionData()" />
    </div>

    <!--<mat-form-field class="form-element field-l textfield-mr2 hide">
      <mat-label>From Date</mat-label>
      <input matInput [matDatepicker]="startpicker" [(ngModel)]="fromDate">
      <mat-datepicker-toggle matSuffix [for]="startpicker"></mat-datepicker-toggle>
      <mat-datepicker #startpicker></mat-datepicker>
    </mat-form-field>

    <mat-form-field class="form-element field-l textfield-mr2 hide">
      <mat-label>To Date</mat-label>
      <input matInput [matDatepicker]="endpicker" [(ngModel)]="toDate">
      <mat-datepicker-toggle matSuffix [for]="endpicker"></mat-datepicker-toggle>
      <mat-datepicker #endpicker></mat-datepicker>
    </mat-form-field>-->


  </div>
  <jqxGrid #dataGrid [theme]="'material-purple'" class="trans-grid" (onSort)="dataGridOnSort($event)" (onPagesizechanged)="onPageSizeChanged($event)"
           [width]="'100%'" [source]="dataAdapter" [columns]="columns"
           [pageable]="true" [sortable]="true" [editable]="false"
           [autoheight]="true" [enabletooltips]="true" [pagermode]="'default'"
           [virtualmode]="true" [rendergridrows]="rendergridrows" [pagesizeoptions]="['10','20','50']" (onBindingcomplete)="Bindingcomplete($event)">
  </jqxGrid>

  <div class="followupAddComponent">
    <ngx-smart-modal #modal identifier="myModal" customClass="'modal'">
      <h4 class="modal-title">{{modalTitle}}</h4>
      
      <add-guestfollowup [message]="msg"
                         (itemChange)="onSubmit($event)"
                         [operationType]="dbops"
                         [selectedMember]="selectedUser"
                         [currentScreen]="currentScreen"
                         [isAdminUser]="isAdminUser"
                         [isPartialAdminUser]="isPartialAdminUser"></add-guestfollowup>
    </ngx-smart-modal>
  </div>

</div>

